import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const AppRoot = styled.div`
  height: 100vh;
  width: 100%;
`;

export const MainContainer = styled.main`
  height: calc(100% - 48px);
  min-height: calc(100vh - 48px);
  background-color: ${colors.greyBg};
  display: flex;
  flex-direction: column;
`;

export const AccessDeniedContainer = styled.div`
  background-color: ${colors.white};
  width: 100%;
  height: 100%;
`;

export const NoPermissions = styled.div`
  height: 100%;
  background-color: ${colors.white};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.3px;
`;
